import { useEffect, useState } from "react";
import { KTCard} from "../../../_metronic/helpers";
import "./style.css";
import axios from "axios";
import { toast } from "react-toastify";
import { OrgHeader } from "./header/OrgHeader";
import { OrgTable } from "./table/OrgTable";
import { useAuth } from "../auth";
import { useDebounce } from "../../../_metronic/helpers";
import { useSearchParams, useNavigate } from "react-router-dom";
import { generateURL } from "../../../_metronic/helpers/utils";

const Index = () => {
    const { currentUser, haveAccess } = useAuth();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [organizations, setOrganizations] = useState([]);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sort, setSort] = useState({ id: 4, key: 'org_creation', order: 'desc' })
    const [status, setStatus] = useState('active');
    const [isLoading, setLoading] = useState(false);
    const searchParamSearch = searchParams.get("search");
    const [lastLocation, setLastLocation] = useState(null);

    const debouncedSearchTerm = useDebounce(search, 180);
    
    useEffect(() => {
        if(searchParamSearch){
          setSearch(searchParamSearch ? searchParamSearch : '')
        }else{
          setSearch("")
        }
      }, [searchParams]);


    const getOrganizations = () => {
        setLoading(true)
        axios.get(`${process.env.REACT_APP_API_V3_URL}/org?page=${page}&page_size=${pageSize}&status=${status}&sort=${sort?.id}&name=${encodeURIComponent(debouncedSearchTerm?.trim())}`)
            .then((res) => {
                const response = res.data;
                setOrganizations(response?.orgs);
                setTotal(response?.total);
                setLoading(false)
            })
            .catch((err) => {
                setLoading(false)
                toast.error(err?.response?.data?.message || 'Could not fetch organizations');
            })
    }


  useEffect(() => {
    if (debouncedSearchTerm !== undefined && search !== undefined) {
      const newUrl = generateURL('/organizations', {
        search: debouncedSearchTerm,
      })

      if (lastLocation && lastLocation !== newUrl) {
        navigate(newUrl)
      }
      setLastLocation(newUrl)
      getOrganizations();
    }
  }, [debouncedSearchTerm, page, pageSize, sort, status]);


  useEffect(() => {
    if(search && debouncedSearchTerm){
      setPage(1);
    }
  }, [debouncedSearchTerm, pageSize]);




    return (
        <KTCard>
            <OrgHeader search={search} setSearch={setSearch} setStatus={setStatus} status={status} />
            {(haveAccess(currentUser, 'org_list')) ? 
                <OrgTable
                organizations={organizations}
                isLoading={isLoading}
                setLoading={setLoading}
                haveAccess={haveAccess}
                currentUser={currentUser}
                fetchOrganizations={getOrganizations}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                total={total}
                sort={sort}
                setSort={setSort}
            />
                :
                <div className='d-flex text-center w-100 align-content-center justify-content-center' style={{ height: '70vh', alignItems: 'center', fontSize: '42px', color: '#ffa049', background: 'rgba(0,0,0,0.1)' }}>
                    You do not have permission to view
                </div>
            }
        </KTCard>
    );
};

export default Index;
